import Layout from "../../components/Layout";
import { Container, } from "@mui/material";
import Steppers from "../../components/Shared/Steppers";
import { useLocation } from "react-router-dom";
function NewAppointMent() {
  const location = useLocation();
  const { currentAppointment, pageNumber, isReschedule } = location.state ?? {};
  return (
    <>
      <Layout>
        <Container className="p-1" disableGutters maxWidth={false}>
          <Steppers
            currentAppointment={currentAppointment ?? undefined}
            pageNumber={pageNumber ?? undefined}
            isReschedule={isReschedule ?? false}
          />
        </Container>
      </Layout>
    </>
  )
}

export default NewAppointMent;